import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../components/landingPage/main"));

const LandingPage = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default LandingPage